import { render } from "./SendSurvey.vue?vue&type=template&id=6ea29fb8&scoped=true"
import script from "./SendSurvey.vue?vue&type=script&lang=js"
export * from "./SendSurvey.vue?vue&type=script&lang=js"

import "./SendSurvey.vue?vue&type=style&index=0&id=6ea29fb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea29fb8"]])

export default __exports__